import Cookies from 'js-cookie';

export const save = (key, value) => Cookies.set(key, value, { path: '/' });
export const load = (key) => Cookies.get(key);
export const remove = (key) => Cookies.remove(key, { path: '/' });
export const isCookieSet = (key) => Cookies.get(key) !== undefined;
